import { render, staticRenderFns } from "./KButton.vue?vue&type=template&id=1e893b1e&scoped=true&"
import script from "./KButton.vue?vue&type=script&lang=js&"
export * from "./KButton.vue?vue&type=script&lang=js&"
import style0 from "./KButton.vue?vue&type=style&index=0&id=1e893b1e&prod&scoped=true&lang=scss&"
import style1 from "./KButton.vue?vue&type=style&index=1&id=1e893b1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e893b1e",
  null
  
)

export default component.exports